module.exports = __webpack_public_path__ + "img/effect.a57e05c6.png";